"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
/* eslint-disable react/jsx-max-depth */
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const shiftTZLocalToUTC_1 = __importDefault(require("@opsbase/lib-time/helpers/shiftTZLocalToUTC"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
const react_big_calendar_1 = require("react-big-calendar");
const useOpScheduleCalendar_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendar"));
const useOpScheduleCalendarActions_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendarActions"));
const useOpScheduleCalendarSelection_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendarSelection"));
const localizer = (0, react_big_calendar_1.momentLocalizer)(moment_timezone_1.default);
const makeMyClasses = () => {
    return {
        root: {
            height: '100%',
            width: '100%',
            backgroundColor: lib_palette_1.default.WhiteSmoke.main,
            '& .rbc-time-header': { background: lib_palette_1.default.White.main },
            '& .rbc-time-header .rbc-header': { borderBottom: 0 },
            '& .rbc-month-header': { background: lib_palette_1.default.White.main },
            '& .rbc-time-gutter': { background: lib_palette_1.default.White.main },
            '& .rbc-allday-cell': { display: 'none' },
            '& .rbc-time-header.rbc-overflowing': { borderRight: 0 },
            '& .rbc-header': { padding: '16px 0 16px 0', fontSize: 14 },
            '& .rbc-calendar': { fontSize: 12, fontFamily: 'Gilroy' },
            '& .rbc-time-view': { border: 0 },
            '& .rbc-today': { backgroundColor: lib_palette_1.default.NoteYellow.main },
            '& .rbc-off-range-bg': { backgroundColor: lib_palette_1.default.Grey.main },
            '& .rbc-show-more': {
                marginLeft: 2,
            },
            '& .rbc-event': { flexFlow: 'unset' },
            '& .rbc-event-content': { height: 'auto' },
            '& .rbc-event-label': { display: 'none' },
            '& .rbc-selected': {
                color: lib_palette_1.default.secondary.contrastText,
                backgroundColor: lib_palette_1.default.secondary.main,
                '&:hover': {
                    color: lib_palette_1.default.primary.contrastText,
                    backgroundColor: lib_palette_1.default.primary.main,
                },
            },
        },
        event: {
            outline: 'none !important',
            transition: 'background-color 0.3s, border-color 0.3s, color 0.3s',
            backgroundColor: lib_palette_1.default.White.main,
            border: `1px solid ${lib_palette_1.default.GreyBlue.main} !important`,
            color: `${lib_palette_1.default.BlackCoral.main} !important`,
        },
        selected: {
            backgroundColor: lib_palette_1.default.secondary.main,
            color: `${lib_palette_1.default.secondary.contrastText} !important`,
            boxShadow: `0 0 20px -4px ${lib_palette_1.default.BlackCoral.main}`,
        },
        unselected: {},
    };
};
const Calendar = function ({ onAddEvent, isEditable = true }) {
    const { date, calendarView, events } = (0, useOpScheduleCalendar_1.default)();
    const { selectedEvent, selectedSchedule } = (0, useOpScheduleCalendarSelection_1.default)();
    const { doSelectEvent } = (0, useOpScheduleCalendarActions_1.default)();
    const [newEvent, setNewEvent] = (0, react_1.useState)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const getEventProp = (0, react_1.useMemo)(() => {
        const c1 = (0, web_css_1.cx)(myCss.event, myCss.selected, calendarView);
        const c2 = (0, web_css_1.cx)(myCss.event, myCss.unselected, calendarView);
        const schedId = selectedSchedule === null || selectedSchedule === void 0 ? void 0 : selectedSchedule.id;
        return (evt) => { var _a; return ({ className: ((_a = evt === null || evt === void 0 ? void 0 : evt.opSchedule) === null || _a === void 0 ? void 0 : _a.id) === schedId ? c1 : c2 }); };
    }, [calendarView, myCss, selectedSchedule]);
    const handleSelectEvent = (0, react_1.useCallback)((v, e) => {
        e.stopPropagation();
        if (v === null || v === void 0 ? void 0 : v.isAddPlaceholder) {
            setNewEvent(undefined);
            return onAddEvent({
                start: (0, shiftTZLocalToUTC_1.default)((0, moment_timezone_1.default)(v.start)),
                end: (0, shiftTZLocalToUTC_1.default)((0, moment_timezone_1.default)(v.end)),
            });
        }
        doSelectEvent(v);
        setNewEvent(undefined);
    }, [doSelectEvent, onAddEvent]);
    const handleSelectSlot = (0, react_1.useCallback)(v => {
        if (!isEditable)
            return;
        if (!!selectedEvent)
            return doSelectEvent(undefined);
        if (!(v === null || v === void 0 ? void 0 : v.start) || !(v === null || v === void 0 ? void 0 : v.end))
            return setNewEvent(undefined);
        if ((newEvent === null || newEvent === void 0 ? void 0 : newEvent.start.getTime()) === v.start.getTime() || !(v === null || v === void 0 ? void 0 : v.start))
            return setNewEvent(undefined);
        setNewEvent(Object.assign({ title: 'Click to add', isAddPlaceholder: true }, v));
    }, [doSelectEvent, isEditable, newEvent === null || newEvent === void 0 ? void 0 : newEvent.start, selectedEvent]);
    return (react_1.default.createElement("div", { className: myCss.root },
        react_1.default.createElement(react_big_calendar_1.Calendar, { toolbar: false, view: calendarView, date: date.toDate(), localizer: localizer, events: newEvent && isEditable ? [...events, newEvent] : events, selectable: true, selected: newEvent && isEditable ? newEvent : null, showMultiDayTimes: true, eventPropGetter: getEventProp, onSelectEvent: handleSelectEvent, onSelectSlot: handleSelectSlot })));
};
exports.Calendar = Calendar;
exports.default = exports.Calendar;
